export default __webpack_public_path__ + "static/media/stonewell_logo_blk.b58daec9.png";